export default __webpack_public_path__ + "static/media/icon-topics.9af66965.svg";